import React from "react";
import Lottie from "react-lottie";
import servicesAnimation from "assets/lottie/cool/cool_03.json";
import workflowAnimation from "assets/lottie/team/team_05.json"; // Workflow animation
import bgDesktop from "assets/images/bgs/purple_02_desktop.svg";

const Logo = () => (
  <span className="font-title font-extrabold leading-tight">
    <span
      style={{ fontFamily: "Barriecito, sans-serif" }}
      className="text-yellow-400"
    >
      BitBit
    </span>{" "}
    Studio
  </span>
);

const Services = () => {
  const workflowOptions = {
    loop: true,
    autoplay: true,
    animationData: workflowAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid meet",
    },
  };

  const servicesOptions = {
    loop: true,
    autoplay: true,
    animationData: servicesAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid meet",
    },
  };

  return (
    <div className="w-full min-h-screen bg-slate-900 text-white py-16 px-4 flex flex-col items-center">
      {/* Services Animation */}
      <div className="flex flex-col justify-center items-center relative w-[300px] md:w-[600px] mb-12">
            {/* Background Image */}
            <img
                src={bgDesktop}
                alt="Background"
                className="w-full h-full"
            />

            {/* Animation on Top */}
            <div className="absolute flex justify-center items-center">
                <Lottie
                options={servicesOptions}
                style={{ width: "70%", height: "80%", cursor: "default" }}
                isClickToPauseDisabled={true}
            />
        </div>
    </div>

      <h1 className="text-4xl md:text-5xl font-title font-extrabold text-center mb-12">
        Our Services
      </h1>

      <div className="w-full lg:w-[90%] mx-auto text-center lg:text-left">
        <p className="text-lg md:text-xl font-body leading-relaxed mb-8">
          At <Logo />, we offer a wide range of animation services designed to
          bring your ideas to life. Whether you need custom animations,
          explainer videos, or vibrant festival visuals, we’ve got you covered.
          Our experienced team works closely with clients to craft high-quality
          animations that captivate and inspire.
        </p>
        <p className="text-lg md:text-xl font-body leading-relaxed mb-8">
          From corporate videos that deliver a clear message to artistic
          animations that spark imagination, we tailor each project to your
          specific needs. Our goal is to create stunning visual experiences that
          leave a lasting impression.
        </p>
      </div>

      {/* Workflow Section */}
      <div className="w-full rounded-3xl bg-gradient-to-t from-indigo-700 to-purple-900 py-16 px-4 text-center mt-16">
        <h2 className="text-3xl md:text-4xl font-title font-extrabold mb-8">
          Our Workflow
        </h2>
        <div className="w-full lg:w-[90%] mx-auto flex flex-col lg:flex-row items-center gap-12">
          {/* Workflow Animation */}
          <div className="w-full lg:w-1/2">
            <Lottie
              options={workflowOptions}
              style={{ width: "100%", height: "100%", cursor: "default" }}
              isClickToPauseDisabled={true}
            />
          </div>

          {/* Workflow Description */}
          <div className="w-full lg:w-1/2 text-center lg:text-left">
            <p className="text-lg md:text-xl font-body leading-relaxed mb-8">
              We start with a simple conversation—over coffee, of course! This
              helps us understand your brand, your goals, and your creative
              vision. Once we’re on the same page, we move through each step of
              the process together, ensuring you’re involved and having fun
              along the way.
            </p>
            <p className="text-lg md:text-xl font-body leading-relaxed mb-8">
              Our process includes <strong>script writing</strong>,{" "}
              <strong>design</strong>, <strong>storyboarding</strong>,{" "}
              <strong>animation</strong>, <strong>editing</strong>, and{" "}
              <strong>sound design</strong>. You’ll be part of our team
              throughout the project, collaborating on the fun, creative aspects
              while we handle the rest.
            </p>
            <p className="text-lg md:text-xl font-body leading-relaxed">
              By working hand-in-hand with you, we ensure the final product not
              only meets but exceeds your expectations. Let’s create something
              amazing together!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
